export const MANAGER_TYPE = "manager";
export const REVIEWER_TYPE = "reviewer";
export const NO_SECTION_SIGN_OFF_TYPE = "no sign off";

export const LEARNER_TYPE = "learner";

export const ADVISER = "adviser";
export const STUDENT = "student";
export const TEACHER = "teacher";
export const SUPER_ADMIN = "super-admin";
export const SCHOOL_ADMIN = "school-admin"; // school-admin is now 'teacher' role
